import { doDefaultFetch } from '@nhl/fetch-helpers';

const fetchGuidesByTeamData = args => {
    return doDefaultFetch(
        `/site/api/guides/${args.season}` +
        `?mapBy=teamId` +
        `&include=team.commonName` +
        `&include=team.placeName` +
        `&include=team.fullName` +
        `&include=team.triCode` +
        `&include=team.logos`,
        args
    );
};

export default {
    fetchGuidesByTeamData
};
